import t from"styled-components";const e=t.aside`
	display: flex;
	flex-direction: column;
	gap: 20px;
	border-left: 1px solid #e6e6e1;
	background: ${({theme:t})=>t.bg.general};
	box-shadow: -4px 0px 10px -85px rgba(0, 0, 0, 0.04);
	padding: 24px 16px 100px;
	box-sizing: border-box;
	overflow-y: auto;
	height: calc(100vh - 75px);
`,i=t.div`
	cursor: pointer;
`,o=t.div`
	display: flex;
	align-items: center;
	gap: 8px;
	border-bottom: 1px solid #0000001a;
	padding-bottom: 8px;
`,n=t.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${({asChild:t=!1})=>!t&&"\n\t\t\tborder-bottom: 1px solid #0000001a;\n\t\t\tpadding-bottom: 8px;\n\t"}
`,p=t.h1`
	margin: 0;
	font-family: "PP Formula";
	color: ${({theme:t})=>t.text.title};
	font-size: 16px;
	font-weight: 400;
`,d=t.span`
	background-color: ${({theme:t})=>t.bg.secondary};
	border-radius: 4px;
	padding: 4px 8px;
	font-size: 12px;
	font-weight: 510;
	line-height: 12px;
	color: ${({theme:t})=>t.text.input};
`,r=t.div`
	display: flex;
	flex-direction: column;
	gap: 32px;

	& > div:not(:first-child) {
		border-top: 1px solid #0000001a;
	}
`,x=t.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	&:not(:first-child) {
		padding-top: 16px;
	}
`,l=t.h1`
	margin: 0;
	font-size: 12px;
	font-family: "PP Formula";
	color: ${({theme:t})=>t.text.title};
	font-weight: 400;
`,a=t.div`
	display: flex;
	flex-direction: ${({flexDirection:t="row"})=>t};
	justify-content: space-between;
	align-items: ${({alignItems:t="center"})=>t};
	gap: ${({gap:t=0})=>t}px;

	${({alignItems:t})=>"start"===t&&"\n\t\t& > span {\n\t\t\tpadding-top: 14px;\n\t\t}\n\t"}

	${({flexDirection:t="row"})=>"column"===t&&"\n\t\t& > div {\n\t\t\twidth: 100%;\n\t\t}\n\t"}
`,s=t.span`
	font-size: 12px;
	line-height: 1.1;
	color: ${({theme:t})=>t.text.text};
`,c=t.div`
	width: 160px;
	flex-shrink: 0;
`,g=t.div`
	border-radius: 8px;
	background-color: ${({theme:t})=>t.bg.primary};
	padding: 4px;
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
`,f=t.div`
	width: 32px;
	height: 32px;
`,h=t.span`
	font-size: 12px;
	color: ${({theme:t})=>t.text.text};
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
`;t.img`
	width: 32px;
	height: 32px;
	border-radius: 4px;
	object-fit: cover;
`;export{h as ImageName,f as ImageOption,g as ImageOptionContainer,a as OptionContainer,c as OptionContent,s as OptionLabel,x as SettingsOptionContainer,l as SettingsOptionHeading,r as SettingsOptionsContainer,i as SidebarCloseButton,e as SidebarContainer,n as SidebarHeader,o as SidebarHeaderContainer,p as SidebarHeading,d as SidebarLabel};
